import React from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield} from 'lucide-react';
import './RealEstateLandingPage.css';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { useMediaQuery } from '@mui/material';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Smart Lead Capture',
    description: 'Capture customer information through intelligent forms designed to extract essential real estate details and buyer preferences.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'AI-Powered Lead Qualification',
    description: 'Automatically qualify leads based on budget, timeline, property preferences, and engagement patterns using advanced AI algorithms.'
  },
  {
    icon: <Code className="icon" />,
    title: 'Lead Scoring Engine',
    description: 'Our AI processes lead data, assigns quality scores (Hot, Warm, Cold), and prioritizes prospects for your sales team.'
  },
  {
    icon: <Database className="icon" />,
    title: 'Comprehensive Lead Database',
    description: 'Store and organize all lead information securely with detailed contact history, property interests, and communication logs.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Real-Time Analytics Dashboard',
    description: 'Visualize key metrics: conversion rates, lead status distribution, response times, and sales pipeline performance at a glance.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Secure & Compliant',
    description: 'Enterprise-grade security for lead data with GDPR compliance, encryption, and regular backups to protect sensitive information.'
  },
];

const RealEstateLandingPage = () => {
  const navigate = useNavigate();

  const onClickHandle = () => {
    navigate('/realestate/login');
  };

  const isCustomSize = useMediaQuery("(max-width:770px)");
  return (
    <>
    <Header />
      <div className="realestate" style={{padding : '30px'}}>
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Real Estate <span className="highlight">Lead</span> Manager
              </h1>
              <p className="hero-description">
              Empower your real estate business with AI-driven lead management. Automatically capture, qualify, and nurture leads with intelligent scoring, real-time analytics, and seamless integration—all in one platform designed for modern real estate professionals.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              {!isCustomSize &&  <div style={{display : 'flex' , justifyContent : 'space-around'}}>
                <h2 className="features-heading">How It Works</h2>
                <h2 className="features-heading">What We Ask</h2>
              </div>}
              {isCustomSize && <h2 style={{fontSize : '22px'}} className="features-heading">What This AI Utility Does</h2>}
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button onClick={onClickHandle} className="cta-button">
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default RealEstateLandingPage;
